import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/pages/authentication/login/login.component';
import { RegisterComponent } from './components/pages/authentication/register/register.component';
import { ForgotPasswordComponent } from './components/pages/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/pages/authentication/reset-password/reset-password.component';
import { ReferenceDetailsComponent } from './master/reference-details/reference-details.component';
import { ReferencMasterComponent } from './master/referenc-master/referenc-master.component';
import { UserMasterComponent } from './master/user-master/user-master.component';
import { AddUserComponent } from './master/add-user/add-user.component';
import { RoleRolesPermissionsComponent } from './role-roles-permissions/role-roles-permissions.component';
import { UpdateCompanyDetailsComponent } from './update-company-details/update-company-details.component';
import { AuthenticationComponent } from './components/pages/authentication/authentication/authentication.component';
import { NotificatonComponent } from './notificaton/notificaton.component';
import { RoleMasterComponent } from './role-master/role-master.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { InvalidLicenceComponent } from './invalid-licence/invalid-licence.component';
 import { AddRoleComponent } from './add-role/add-role.component';
 import { CustomerSearchComponent } from './customer-search/customer-search.component';
 import { ForgotNewPasswordComponent } from './forgot-new-password/forgot-new-password.component';


const routes: Routes = [
  { path: 'customer-search', component: CustomerSearchComponent },
  { path: 'add-role', component: AddRoleComponent },

  { path: 'invalid-licence', component: InvalidLicenceComponent },
  { path: 'reference', component: ReferenceDetailsComponent },
  { path: 'add-reference', component: ReferencMasterComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'update-company', component: UpdateCompanyDetailsComponent },
  { path: 'user-details', component: UserMasterComponent,data: {animation: 'HomePage'}  },
  { path: 'user-profile', component: UserProfileComponent },
  { path: 'add-user', component: AddUserComponent },
  { path: 'role-permissions', component: RoleRolesPermissionsComponent, data: {animation: 'AboutPage'}  },
  { path: 'notification', component: NotificatonComponent },
  { path: 'role-master', component: RoleMasterComponent ,data: {animation: 'FilterPage'} },
  //{ path: 'forgot-new-password', component: ForgotNewPasswordComponent },
  { path: '', component: LoginComponent },
  //{ path: '', redirectTo: 'authentication/login', pathMatch: 'full' },
  {
    path: 'authentication', component: AuthenticationComponent,
    children: [
      { path: 'login', pathMatch: 'full', data: { breadcrumb: 'Login' }, component: LoginComponent },
      { path: 'register', data: { breadcrumb: 'Register' }, component: RegisterComponent },
      { path: 'forgot-password', data: { breadcrumb: 'Forgot Password' }, component: ForgotPasswordComponent },
      { path: 'reset-password', data: { breadcrumb: 'Reset Password' }, component: ResetPasswordComponent },
    ]
  },

  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
  { path: 'master', loadChildren: () => import('./master/master.module').then(m => m.MasterModule) },
  { path: 'utilities', loadChildren: () => import('./utilities/utilities.module').then(m => m.UtilitiesModule) },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule) },
  { path: 'transaction', loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
